// Full-document render of the Oscar account order-history list: PageSkeleton
// wrapping the legacy sealy orders page -- the "Your Account / Your Orders"
// breadcrumbs, the (possibly CSR owner-named) heading, one shared
// RichOrderDetail block per order with the shared pagination, the two legacy
// empty states, and the customer-service info block. The rich blocks are
// typed-serialized server-side (rich_orders); each order-details toggle is
// owned by its shared block's own disclosure state (collapsible).
import React from "react";
import { Pagination } from "tsi-common-react/src/apps/customer-account/Pagination/index";
import { RichOrderDetail } from "tsi-common-react/src/apps/customer-account/RichOrderDetail/index";

import { templates } from "@reactivated";

import { CustomerServiceInfoBlock } from "../components/CustomerServiceInfoBlock";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.OrderHistoryDocumentTemplate,
): React.JSX.Element => {
    const richOrders = props.rich_orders ?? [];
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width u-margin-bottom--xl u-full-width-title order-list">
                <section className="breadcrumbs-block">
                    <a href={props.profile_url}>Your Account</a> / Your Orders
                </section>

                <h2>{props.orders_heading}</h2>

                <div
                    className={`content__copy--full-width content__orders-page${
                        richOrders.length
                            ? ""
                            : " content__orders-page--empty-order-status"
                    }`}
                >
                    <div className="orders">
                        <ul className="orders__list">
                            {richOrders.length ? (
                                <>
                                    {richOrders.map((order, i) => (
                                        <li
                                            key={i}
                                            className="orders__list-item"
                                        >
                                            <div className="content__copy--full-width order-summary-wrapper">
                                                <RichOrderDetail
                                                    {...order}
                                                    collapsible={true}
                                                />
                                            </div>
                                        </li>
                                    ))}
                                    {props.pagination && (
                                        <Pagination data={props.pagination} />
                                    )}
                                </>
                            ) : props.form_is_bound ? (
                                <li className="orders__list-item">
                                    No orders match your search.
                                </li>
                            ) : (
                                <li className="orders__list-item orders__list-item--empty-order-status">
                                    <h2 className="orders__list-item__title orders__list-item__title--empty-order-status">
                                        You haven&apos;t shopped with us.
                                    </h2>
                                    <p className="orders__list-item__copy orders__list-item__copy--empty-order-status">
                                        Please check back after your first
                                        purchase to view your order details.
                                    </p>
                                    <a
                                        className="button"
                                        href={props.root_page_url}
                                    >
                                        Shop now
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>

            {props.cs_info && <CustomerServiceInfoBlock info={props.cs_info} />}
        </PageSkeleton>
    );
};
